import * as utils from './utils.js'
import { initPrllx } from './prllx.js'
import { initAPropos } from './pages/a-propos.js';
import { initHome } from './pages/home.js';
import { initLaboratoire } from './pages/laboratoire.js';
import { initLeCollage } from './pages/le-collage.js';
import { initLeDosage } from './pages/le-dosage.js';
import { initPress } from './pages/press.js';
import { initRealisations } from './pages/realisations.js';
import { initSingleRealisation} from './pages/single-realisation.js';
import { initSingleProduit } from './pages/single-produit.js';
import { initSolutionsCollage } from './pages/solutions-collage.js';
import { initSolutionsDosage } from './pages/solutions-dosage.js';
import { initSousCategorie } from './pages/sous-categorie.js';
import { initProblematiques } from './pages/problematiques.js';
import { initSingleProblematiques } from './pages/single-problematiques.js';
import { initAppelProjet } from './pages/appel-projet.js';
import { initFichesTechniques } from "./pages/fiches-techniques";
import { initLaboV2 } from "./pages/laboratoire-v2.js";
import { gtmEventsInit, gtmEventsOnPageChange } from "./gtm-events.js";

window.promoOpened = false;

class App {

    constructor(opt = {}) {

        window.scrollTo(0, 0)
        console.log("%cCreated by Wokine", "color: #000; padding: 5px 0px;"), console.log("%chttp://wokine.com", "color:#ccc")

        this.init()
        this.addEvents()
        this.barba()
        this.initSwitchLanguage()
    }

    init() {
        //removeLoading


        //smoothScroll
        $('a[href^="#"]').click(function() {
            var the_id = $(this).attr("href");

            $('html, body').animate({
                scrollTop: $(the_id).offset().top - 200
            }, 'slow');
            return false;
        });

        $('body').addClass($('main').data("pageclass"));
        document.querySelector('body').classList.remove('is-loading');


        // Dropdown nav header ⤵️
        $("li.dropdown").on("click", function(e) {
            if (!$(this).find("ul.dropdown").hasClass('show-dropdown')) {
                $(this).addClass('show-dropdown');
                $(this).removeClass('hide-dropdown');
                $(this).find("ul.dropdown").addClass('show-dropdown');
                $(this).find("ul.dropdown").removeClass('hide-dropdown');

            } else {
                $(this).removeClass('show-dropdown');
                $(this).addClass('hide-dropdown');
                $(this).find("ul.dropdown").removeClass('show-dropdown');
                $(this).find("ul.dropdown").addClass('hide-dropdown');
            }

        });

        if (window.Sniff && window.Sniff.browser.name === "ie") {
            $("body").addClass("ie");
            $('header a').addClass('no-barba');
            console.log("ie");

        } else if (window.Sniff && window.Sniff.browser.name === "edge") {
            $("body").addClass("edge");
            $('header a').addClass('no-barba');
            console.log("edge");
        }



        //lab video
        if ($('.plyr-container').length > 0) {
            const videoPlyr = plyr.setup('.plyr-container');
            const $videoPlyrContainer = $('.plyr-container');

            $videoPlyrContainer.find('.cover').on('click', function(e) {
                e.preventDefault();
                //videoPlyr[0].seek(0);
                videoPlyr[0].play();
            });
            $videoPlyrContainer.find('.plyr').on('click', function(e) {
                e.preventDefault();
                //videoPlyr[0].pause();
            });

            videoPlyr[0].on('play', function(event) {
                $videoPlyrContainer.addClass("playing");
            });

            videoPlyr[0].on('pause', function(event) {
                //$videoPlyrContainer.removeClass("playing");
            });
        }




        $(window).scroll(function() {
            var offset = ($(document).scrollTop()) / 2;
            if (offset > 10) {
                $("header").addClass("scroll");
            } else {
                $("header").removeClass("scroll");
            }
        });

    }

    addEvents() {
        window.onbeforeunload = function() {
            window.scrollTo(0, 0);
        }

        gtmEventsInit();
    }

    barba() {

        Barba.Dispatcher.on('newPageReady', function(currentStatus, oldStatus, container) {

            gtmEventsOnPageChange()

            // reboot dropdown menu responsive
            $("ul.full-dropdown").removeClass('show-dropdown');
            $("ul.full-dropdown").addClass('hide-dropdown');

            if (container.dataset.popup == 1) {

                console.log('Promo Popup');

                //console.log("PopupShowed : `${sessionStorage.getItem("lastDatePopupShowed")}`");

                if (!sessionStorage.getItem("lastDatePopupShowed")) {

                    var promoOpened = false;
                    $(window).scroll(function() {
                        var offsetScroll = $(document).scrollTop();
                        if (offsetScroll > 100 && !promoOpened) {
                            $.magnificPopup.open({
                                items: {
                                    src: '#ModalPromo'
                                },
                                removalDelay: 400,
                                fixedContentPos: true,
                                mainClass: 'mfp-promo',
                                type: 'inline'
                            });

                            promoOpened = true;
                        }
                    });

                    sessionStorage.setItem('lastDatePopupShowed', "true");

                } else {
                    return;
                }

                $(window).scroll(function() {
                    var offsetScroll = $(document).scrollTop();
                    if (offsetScroll > 100 && !window.promoOpened) {
                        $.magnificPopup.open({
                            items: {
                                src: '#ModalPromo'
                            },
                            removalDelay: 400,
                            fixedContentPos: true,
                            mainClass: 'mfp-promo',
                            type: 'inline'
                        });

                        window.promoOpened = true;
                    }
                });
            }


            var inputs = document.querySelectorAll('.inputfile');
            Array.prototype.forEach.call(inputs, function(input) {
                var label = input.nextElementSibling,
                    labelVal = label.innerHTML;

                input.addEventListener('change', function(e) {
                    var fileName = '';
                    if (this.files && this.files.length > 1)
                        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                    else
                        fileName = e.target.value.split('\\').pop();

                    if (fileName)
                        label.querySelector('span').innerHTML = fileName;
                    else
                        label.innerHTML = labelVal;
                });
            });

            $("#principal-navbar ul li").removeClass("active");

            var slug = $(container).data("namespace")

            $('*[data-slug=' + slug + ']').addClass("active");

            if ($("#formContact").length) {

                $("#addFile").on("click", function() {
                    var self = $(this);
                    var li = $("<div class='file'><span></span><a href=\"#\" class=\"link deletefile no-barba\">Supprimer</a></div>")
                    var myfile = $("<input type='file' accept=\"application/pdf, application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/pdf,image/*, application/vnd.openxmlformats-officedocument.wordprocessing‌​ml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.‌​sheet, application/vnd.openxmlformats-officedocument.presentationml‌​.slideshow\" name='pi_ces_jointes[]' class='hide file_input' />");
                    myfile.on("change", function() {
                        $(li).appendTo('.filesrow .files__container');
                        $(myfile).appendTo('.filesrow .files__container');
                        var filename = $(this).val().split('\\').pop();
                        li.find("span").text(filename);

                        if ($(".files__container .file").length >= 3) {
                            self.prop('disabled', true).addClass("disabled");
                            self.siblings("label").find("span").text("Nombre maximum atteint");
                        } else {
                            self.prop('disabled', false).removeClass("disabled");
                            self.siblings("label").find("span").text("Envoyer une pièce jointe");
                        }
                    })


                    myfile.trigger("click");

                })

                $(document).on('click', '.deletefile', function(e) {
                    e.preventDefault();
                    $(this).parent().remove();
                    if ($(".files__container .file").length >= 3) {
                        $("#addFile").prop('disabled', true).addClass("disabled");
                        $("#addFile").siblings("label").find("span").text("Nombre maximum atteint");
                    } else {
                        $("#addFile").prop('disabled', false).removeClass("disabled");
                        $("#addFile").siblings("label").find("span").text("Envoyer une pièce jointe");
                    }
                });


                /*			$("#formContact").submit(function (e) {

                				e.preventDefault();

                				var _this = $(this);

                				// _this.parsley().reset();
                				$(".error-form, .success-form").hide()
                				if (_this.parsley().isValid()){
                          $("body").css("cursor", "wait");
                          $("#submitFormContact").attr("disabled", true).css( 'cursor', 'not-allowed');
                					$.ajax({

                						cache: false,
                						contentType: false,
                						processData: false,

                						url: _this.data("ajaxurl"),
                						method: "POST",        // Custom XMLHttpRequest
                /!*                        xhr: function() {
                							var myXhr = $.ajaxSettings.xhr();
                							if (myXhr.upload) {
                								// For handling the progress of the upload
                								myXhr.upload.addEventListener('progress', function(e) {
                									if (e.lengthComputable) {
                										$('progress').attr({
                											value: e.loaded,
                											max: e.total,
                										});
                									}
                								} , false);
                							}
                							return myXhr;
                						},*!/
                						data: new FormData($("#formContact")[0]),
                						success : function (data) {
                							$(".error-form").show().text(data);
                							_this[0].reset()
                              $(".file").remove()
                							$(".file_input").remove()
                							$("body").css("cursor", "default");
                							$("#submitFormContact").attr("disabled", false).css( 'cursor', 'default');
                							_this.trigger('reset');


                						},
                						error : function (resp) {
                							var error_json = JSON.parse(resp.responseText);
                							$("body").css("cursor", "default");
                							$("#submitFormContact").attr("disabled", false).css( 'cursor', 'default');

                							if (error_json.field != ""){
                								if (error_json.file !== false){
                									window.ParsleyUI.addError($("li:nth-child("+(error_json.file+1)+") input[type=file]").parsley(), "myCustomError", error_json.message);
                								} else {
                									window.ParsleyUI.addError($("input[name="+error_json.field+"]").parsley(), "myCustomError", error_json.message);
                								}
                							} else {
                								$(".error-form").show().text(error_json.message);
                							}
                						}
                					})
                				}
                        else {
                          $(".error-form").show().text("Veuillez remplir tous les champs obligatoires");
                        }
                			})*/
            }

            //open contact popup
            /*
            		$('.open-contact-popup').magnificPopup({
            			type:'inline',
            			removalDelay: 300,
            			fixedContentPos:true,
            			mainClass: 'mfp-fade',
            			callbacks : {
            				open: function() {
            					initMap();
            				}
            			}
            		});
            */

            //initPrllx(container);
            $('.navbar-collapse').removeClass('in');


            $(".type-list li").click(function() {
                if (!$(this).hasClass("active")) {
                    $(".type-list li").toggleClass("active");
                    var idToShow = $(this).find("a").data("show");
                    $(".realisations-list, .problematiques-list").hide();
                    $(idToShow).show();
                }
            })

            $('.description .lire-plus').magnificPopup();

            //detect when .process is on the screen
            inView('.process li i')
                .on('enter', el =>
                    el.classList.add('in-view'))
                .on('exit', el => {
                    el.classList.remove('in-view')
                });


        });


        //routes
        initAPropos();
        initHome();
        initLaboratoire();
        initLeCollage();
        initLeDosage();
        initFichesTechniques();
        initPress();
        initRealisations();
        initSingleProduit();
        initSolutionsCollage();
        initSolutionsDosage();
        initSousCategorie();
        initProblematiques();
        initSingleProblematiques();
        initSingleRealisation();
        initAppelProjet();
        initFichesTechniques();
        initLaboV2();

        var pageTransition = Barba.BaseTransition.extend({
            start: function() {
                //http://barbajs.org/transition.html
                Promise
                    .all([this.newContainerLoading, this.fadeOut()])
                    .then(this.fadeIn.bind(this));
            },

            fadeOut: function() {

                /**
                 * this.oldContainer is the HTMLElement of the old Container
                 */

                //return $(this.oldContainer).animate({ opacity: 0 }).promise();
                //je mets en pause la promise
                let deferred = Barba.Utils.deferred();
                let oldContainer = $(this.oldContainer);

                const slideOut = new TimelineMax();
                slideOut.set($('.loader'), {
                    x: '-100%'
                });
                slideOut.to($('.loader'), 0.8, {
                    x: '0%',
                    ease: Power3.easeIn
                }, 0);
                slideOut.to(oldContainer, 0.8, {
                    x: "25%",
                    ease: Power3.easeIn,
                    onComplete: function() {
                        deferred.resolve();
                    }
                }, 0);

                return deferred.promise;

            },

            fadeIn: function() {
                $("body").removeClass('page-' + $(this.oldContainer).data('namespace')).removeClass($(this.oldContainer).data('pageclass'));
                $("body").addClass('page-' + $(this.newContainer).data('namespace'));
                $('body').addClass($(this.newContainer).find("main").data("pageclass"));

                window.scrollTo(0, 0);
                var _this = this;
                var $el = $(this.newContainer);
                $(this.oldContainer).hide();
                $el.css({
                    visibility: 'visible',
                });

                const tlslideIn = new TimelineMax({
                    onComplete: () => {
                        _this.done()
                    }
                });
                tlslideIn.from($el, 0.8, {
                    x: "-400px",
                    ease: Power3.easeOut
                }, 0);
                tlslideIn.to($('.loader'), 0.8, {
                    x: "100%",
                    ease: Power3.easeOut,
                }, 0);
            }

        });

        /**
         * Next step, you have to tell Barba to use the new Transition
         */

        Barba.Pjax.getTransition = function() {
            /**
             * Here you can use your own logic!
             * For example you can use different Transition based on the current page or link...
             */

            return pageTransition;
        };
        Barba.Pjax.start();
    }

    initSwitchLanguage() {
        //console.log('initSwitchLanguage');
        // wait for the DOM to be loaded in pure JS
        document.addEventListener('DOMContentLoaded', function() {
            // get all the elements with the class "lang-switch"
            const elems = document.querySelectorAll('.Lang__switch');
            const ajaxUrl = document.querySelector('.select_language').dataset.ajaxurl;
            // bind a click event to each element
            for (let i = 0; i < elems.length; i++) {
                elems[i].addEventListener('click', function(e) {
                    // prevent the default action for the event
                    e.preventDefault();
                    // get the value of the data-lang attribute from the clicked element
                    const lang = this.getAttribute('data-lang');
                    // http fetch request to action wp_ajax_switch_language
                    const switchLanguageData = new FormData()
                    switchLanguageData.append("url", window.location.href)
                    switchLanguageData.append("lang", lang)
                    const xhr = new XMLHttpRequest()
                    xhr.open('POST', ajaxUrl, true)
                    xhr.onreadystatechange = () => {
                        if (xhr.readyState === XMLHttpRequest.DONE) {
                            const data = JSON.parse(xhr.response);
                            // console.log(data.url);
                            switch (xhr.status) {
                                case 200:
                                    window.location.href = data.url;
                                    break
                                case 422:
                                    // console.log("error :: redirect HP");
                                    window.location.href = window.location.origin +'/'+ lang + "/";
                                    break
                                default:
                                // console.log("error");
                            }
                        }
                    }
                    xhr.send(switchLanguageData)
                });
            }
        });
    }
}

const app = new App();
